export default __webpack_public_path__ + "static/media/ic-scan.0644f069.svg";